// AI工作台翻译模块索引
import { workbench as workbenchEn } from './workbench_en.js';
import { workbench as workbenchTc } from './workbench_tc.js';
import { workbench as workbenchSc } from './workbench_sc.js';
import { tools as toolsEn } from './tools_en.js';
import { tools as toolsTc } from './tools_tc.js';
import { tools as toolsSc } from './tools_sc.js';
import { generation as generationEn } from './generation_en.js';
import { generation as generationTc } from './generation_tc.js';
import { generation as generationSc } from './generation_sc.js';
import { editing as editingEn } from './editing_en.js';
import { editing as editingTc } from './editing_tc.js';
import { editing as editingSc } from './editing_sc.js';
import { faceSwap as faceSwapEn } from './faceSwap_en.js';
import { faceSwap as faceSwapTc } from './faceSwap_tc.js';
import { faceSwap as faceSwapSc } from './faceSwap_sc.js';
import { faceSwapeRoleOptions as faceSwapeRoleOptionsEn } from './faceSwapRoleOptions_en.js';
import { faceSwapeRoleOptions as faceSwapeRoleOptionsTc } from './faceSwapRoleOptions_tc.js';
import { faceSwapeRoleOptions as faceSwapeRoleOptionsSc } from './faceSwapRoleOptions_sc.js';
import { faceSwapeCameraOptions as faceSwapeCameraOptionsEn } from './faceSwapeCameraOptions_en.js';
import { faceSwapeCameraOptions as faceSwapeCameraOptionsTc } from './faceSwapeCameraOptions_tc.js';
import { faceSwapeCameraOptions as faceSwapeCameraOptionsSc } from './faceSwapeCameraOptions_sc.js';
import { faceSwapeStyleOptions as faceSwapeStyleOptionsEn } from './faceSwapeStyleOptions_en.js';
import { faceSwapeStyleOptions as faceSwapeStyleOptionsTc } from './faceSwapeStyleOptions_tc.js';
import { faceSwapeStyleOptions as faceSwapeStyleOptionsSc } from './faceSwapeStyleOptions_sc.js';
import { faceSwapeEnvOptions as faceSwapeEnvOptionsEn } from './faceSwapeEnvOptions_en.js';
import { faceSwapeEnvOptions as faceSwapeEnvOptionsTc } from './faceSwapeEnvOptions_tc.js';
import { faceSwapeEnvOptions as faceSwapeEnvOptionsSc } from './faceSwapeEnvOptions_sc.js';

const workbench = {
  'en': workbenchEn,
  'zh': workbenchSc,
  'zh-TW': workbenchTc,
};
const tools = {
  'en': toolsEn,
  'zh': toolsSc,
  'zh-TW': toolsTc,
};
const generation = {
  'en': generationEn,
  'zh': generationSc,
  'zh-TW': generationTc,
};
const editing = {
  'en': editingEn,
  'zh': editingSc,
  'zh-TW': editingTc,
};


// 合并所有翻译模块
export const aiWorkbench = {
  en: {
    ...workbench.en,
    tools: tools.en,
    ...generation.en,
    ...editing.en,
    faceSwap: faceSwapEn,
    faceSwapeRoleOptions: faceSwapeRoleOptionsEn,
    faceSwapeCameraOptions: faceSwapeCameraOptionsEn,
    faceSwapeStyleOptions: faceSwapeStyleOptionsEn,
    faceSwapeEnvOptions: faceSwapeEnvOptionsEn
  },
  'zh-TW': {
    ...workbench['zh-TW'],
    tools: tools['zh-TW'],
    ...generation['zh-TW'],
    ...editing['zh-TW'],
    faceSwap: faceSwapTc,
    faceSwapeRoleOptions: faceSwapeRoleOptionsTc,
    faceSwapeCameraOptions: faceSwapeCameraOptionsTc,
    faceSwapeStyleOptions: faceSwapeStyleOptionsTc,
    faceSwapeEnvOptions: faceSwapeEnvOptionsTc
  },
  zh: {
    ...workbench.zh,
    tools: tools.zh,
    ...generation.zh,
    ...editing.zh,
    faceSwap: faceSwapSc,
    faceSwapeRoleOptions: faceSwapeRoleOptionsSc,
    faceSwapeCameraOptions: faceSwapeCameraOptionsSc,
    faceSwapeStyleOptions: faceSwapeStyleOptionsSc,
    faceSwapeEnvOptions: faceSwapeEnvOptionsSc
  }
};
